import { intervalToDuration } from "date-fns"

import { TeachingLevel } from "./types"

export const formatTimeSpent = (timeSpent?: Date | null) => {
  if (!timeSpent) return ""

  const end = timeSpent.getTime()
  if (!Number.isFinite(end)) return ""

  const { hours = 0, minutes = 0 } = intervalToDuration({ start: 0, end })
  if (!hours && !minutes) return ""

  return `${hours ? `${hours}h ` : ""}${minutes ? `${minutes}m` : ""}`.trim()
}

export const getByPath = (obj: any, path: string) => {
  if (!obj || !path) return undefined
  return path.split(".").reduce((acc: any, key) => {
    if (acc === undefined || acc === null) return undefined
    return acc?.[key]
  }, obj)
}

export function extractNames<T extends { name?: string }>(arr?: T[]): string[] {
  if (!Array.isArray(arr)) return []
  return arr
    .map((item) => item?.name?.trim())
    .filter((name): name is string => Boolean(name && name.length > 0))
}

export const TeachingLevelLabels: Record<TeachingLevel, string> = {
  [TeachingLevel.Primary]: "Primary Level",
  [TeachingLevel.Middle]: "Middle Level",
  [TeachingLevel.Secondary]: "Secondary Level",
  [TeachingLevel.Senior]: "Senior Level",
}

export type RenderAnalyticsMetric = {
  value: number | null | undefined
  render: (args: { isNum: boolean; formattedValue: string }) => React.ReactNode
  suffix?: string
  renderInTime?: boolean
}

// TODO: After merging all code from other branches remove it. Already added in other branch's code

export const renderAnalyticsMetric = ({
  value,
  render,
  suffix = "",
  renderInTime = false,
}: RenderAnalyticsMetric) => {
  const isNum = typeof value === "number" && !isNaN(value)
  let formattedValue = "_"

  if (isNum) {
    if (renderInTime) {
      if (value === 0) {
        formattedValue = "0h"
      } else {
        const duration = intervalToDuration({
          start: 0,
          end: value * 60 * 1000,
        })
        const hours = duration.hours ?? 0
        const minutes = duration.minutes ?? 0
        formattedValue = `${hours}h ${minutes}min`
      }
    } else {
      formattedValue = `${
        value === 0 ? 0 : Number.isInteger(value) ? value : value.toFixed(1)
      }${suffix}`
    }
  }

  return render({ isNum, formattedValue })
}
